import { Box, VStack } from '@chakra-ui/react';
import { Select } from 'chakra-react-select';
import { dropdownFormStyle } from './dropdownFormStyle';

const BreadcrumbEntityDropdown = ({
    items = [],
    selectedId,
    getLabel,
    onSelect,
    darkMode,
    placeholder = 'Select',
    width = '380px',
    minWidth = '180px',
}) => {
    const options = items.map((item) => ({
        value: item.id,
        label: typeof getLabel === 'function' ? getLabel(item) : item.name,
    }));

    return (
        <Box width={width}>
            <VStack width="100%" alignItems="normal">
                <Select
                    value={
                        options.find((option) => option.value === selectedId) ||
                        null
                    }
                    onChange={(option) => {
                        const selected = items.find(
                            (item) => String(item.id) === String(option?.value),
                        );
                        if (selected) onSelect(selected);
                    }}
                    options={options}
                    placeholder={placeholder}
                    minWidth={minWidth}
                    width="100%"
                    height="auto"
                    chakraStyles={dropdownFormStyle(darkMode)}
                    menuPortalTarget={
                        typeof document !== 'undefined'
                            ? document.body
                            : undefined
                    }
                    styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                />
            </VStack>
        </Box>
    );
};

export default BreadcrumbEntityDropdown;
